'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = JobChart;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Bar = require('./Bar');

var _Bar2 = _interopRequireDefault(_Bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
   {
     "type": "job_chart",
     "title": "JOBS",
     "subtitle": "Many banking jobs waiting for you"
     "data": [
       {
         "label": "Associates Degree",
         "value": 0.1
       },
       {
         "label": "Bachelor's Degree",
         "value": 0.3
       },
       {
         "label": "Master's Degree",
         "value": 0.6
       }
     ]
   }

   This is for rendering the job chart as seen on the subsector template.

   The `data` attribute specifies the bar chart to be rendered.
   Each object will be a bar in the chart.
*/

function JobChart(_ref) {
  var moduleClass = _ref.moduleClass,
      title = _ref.title,
      subtitle = _ref.subtitle,
      data = _ref.data;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-job_chart ' + moduleClass
    },
    _react2.default.createElement(
      'div',
      { className: moduleClass + '-title' },
      _react2.default.createElement(
        'h3',
        null,
        title
      ),
      _react2.default.createElement(
        'p',
        null,
        subtitle
      )
    ),
    _react2.default.createElement(
      'div',
      { className: moduleClass + '-chart' },
      data.map(function (_ref2, key) {
        var barLabel = _ref2.label,
            value = _ref2.value;
        return _react2.default.createElement(_Bar2.default, {
          key: key,
          label: barLabel,
          value: value
        });
      })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobChart/JobChart.jsx
// module id = 1180
// module chunks = 0